import 'bootstrap/dist/css/bootstrap.min.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'admin-lte/dist/css/skins/_all-skins.min.css'
import 'font-awesome/css/font-awesome.min.css'
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'



// WEBPACK FOOTER //
// ./src/lib/css.js